export default __webpack_public_path__ + "static/media/elevate-bbl-1.f93dac6f.png";